export default "__VITE_ASSET__d750bb5b__"